import { toFileReadError } from '@/utils/file';

export const toDataUrl = async (imageUrl: string): Promise<string | null> => {
  try {
    const res = await fetch(imageUrl);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (!reader.result) {
          return resolve(null);
        }
        if (typeof reader.result === 'string') {
          return resolve(reader.result);
        }

        reject(new Error('Unable to convert url to base64 string'));
      };
      reader.onerror = () => reject(toFileReadError(reader));
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    return null;
  }
};

export const imageToFile = async (
  imageUrl: string,
  filename: string
): Promise<File | null> => {
  let dataUrl;
  try {
    dataUrl = await toDataUrl(imageUrl);
  } catch (err) {
    throw new Error('Unable to download image', { cause: err });
  }

  if (!dataUrl) {
    return null;
  }

  const parts = dataUrl.split(',');
  const mime = parts[0].match(/:(.*?);/)?.[1];
  const bstr = atob(parts[1]);

  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
